function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import { jsx } from 'panel';
import { TooltipEl } from 'common/components/tooltip';
import { SvgIconEl } from 'common/components/svg-icon';
import { Placement } from 'common/components/tooltip/types';
import { getReportNameFromSearchContext, getSearchIconFromDisplayContext } from 'common/report/util/search';
import { RowEntity } from 'common/widgets/entity-collection/entity-table/types';
import { getDashboardAllowedReports } from 'common/report/util/boards';
import { TEXT_HIGHLIGHT_THEME, TextHighlightEl } from 'common/components/text-highlight';
import { CurrentProject } from 'common/report/model-resources/projects';
function getEntitySublabel(entity: RowEntity, currentProject: CurrentProject | null): string {
  const report = getReportNameFromSearchContext(entity.displayContext);
  const isDashboardAllowedReport = getDashboardAllowedReports(currentProject).includes(report);
  return isDashboardAllowedReport ? entity.dashboard : "";
}
export const CellEntityNameWithIcon = (_ref: {
  entity: RowEntity;
  currentProject: CurrentProject | null;
  entityDisplayIconTooltip: string;
  skipEntityLinks: boolean;
  skipEntityIcon?: boolean;
}) => {
  let {
    entity,
    currentProject,
    entityDisplayIconTooltip,
    skipEntityLinks,
    skipEntityIcon
  }: {
    entity: RowEntity;
    currentProject: CurrentProject | null;
    entityDisplayIconTooltip: string;
    skipEntityLinks: boolean;
    skipEntityIcon?: boolean;
  } = _ref;
  const entityIcon = skipEntityIcon ? null : getSearchIconFromDisplayContext(entity.displayContext);
  const entitySubLabel = getEntitySublabel(entity, currentProject);
  const Badge = (text: string, tooltipText: string, theme: TEXT_HIGHLIGHT_THEME) => {
    return <span sel='.cell-entity-badge' data-sentry-component="Badge" data-sentry-source-file="cell-renderers.tsx">
        <TextHighlightEl attrs={{
        text,
        theme
      }} data-sentry-element="TextHighlightEl" data-sentry-source-file="cell-renderers.tsx" />
        <TooltipEl attrs={{
        placement: Placement.RightCenter,
        'max-width': "250px"
      }} data-sentry-element="TooltipEl" data-sentry-source-file="cell-renderers.tsx">{tooltipText}</TooltipEl>
      </span>;
  };
  return <div sel='.cell-entity-name' class={{
    disabled: entity.isRowClickDisabled
  }} data-sentry-component="CellEntityNameWithIcon" data-sentry-source-file="cell-renderers.tsx">
      {entityIcon ? <div sel='.cell-entity-icon'>
          <SvgIconEl attrs={{
        icon: entityIcon
      }} />
          <TooltipEl attrs={{
        placement: Placement.Right
      }}>{entityDisplayIconTooltip}</TooltipEl>
        </div> : null}
      <div sel='.cell-entity-title'>
        <a sel='.entity-link' attrs={_objectSpread({}, skipEntityLinks ? {} : {
        href: entity.link
      })}>
          {entity.name}
        </a>
        {entity.showDraftBadge && Badge("Draft", "This Mixpanel board is currently a draft of a template. While in draft mode you cannot edit the board or add to the board until you\u2019ve completed setting up the template.", TEXT_HIGHLIGHT_THEME.FAILED)}
        {entity.isRowClickDisabled && Badge("No access", "This content is not shared with you.", TEXT_HIGHLIGHT_THEME.GENERIC)}
        {entitySubLabel ? <div sel='.cell-entity-description'>{entitySubLabel}</div> : null}
      </div>
    </div>;
};